import React from 'react';
import PropTypes from 'prop-types';
import rLStyles from './RecordsList.module.scss';
import AnyChildren from '../../propTypes/AnyChildren';

const RLHeaderRow = ({ children, className = '', ...props }) => {
  const classNames = `${className} ${rLStyles.headerRow}`;
  return <tr className={classNames} {...props}>{children}</tr>;
};

RLHeaderRow.propTypes = {
  children: AnyChildren,
  className: PropTypes.string,
};

export default RLHeaderRow;
